import { makeActionCreator } from '../../../utilities'
import { PatientMedicalHistoryConstants } from './patientMedicalHistory.constants'

export const setPatientMedicalHistory = makeActionCreator(
  PatientMedicalHistoryConstants.SET_PATIENT_MEDICAL_HISTORY,
  'patientMedicalHistory'
)
export const setNoKnownHistory = makeActionCreator(
  PatientMedicalHistoryConstants.SET_NO_KNOWN_HISTORY,
  'noKnownHistory'
)
export const setSavePatientMedicalHistoryResponse = makeActionCreator(
  PatientMedicalHistoryConstants.SET_RESPONSE,
  'response'
)
export const resetPatientMedicalHistoryState = makeActionCreator(PatientMedicalHistoryConstants.RESET_STATE)
export const setSelectedMedicalHistory = makeActionCreator(
  PatientMedicalHistoryConstants.SET_SELECTED_MEDICAL_HISTORY,
  'medicalHistory'
)
export const setSelectedMedicalHistoryPNNV = makeActionCreator(
  PatientMedicalHistoryConstants.SET_SELECTED_MEDICAL_HISTORY_PNNV,
  'medicalHistoryPNNV'
)
export const setSelectedMedicalHistoryIcdNemsisBasic = makeActionCreator(
  PatientMedicalHistoryConstants.SET_SELECTED_MEDICAL_HISTORY_ICD_NEMSIS_BASIC,
  'medicalHistoryIcdNemsisBasic'
)
export const setObtainedFrom = makeActionCreator(PatientMedicalHistoryConstants.SET_OBTAINED_FROM, 'obtainedFrom')

export const setEmergencyInfoForm = makeActionCreator(
  PatientMedicalHistoryConstants.SET_EMERGENCY_INFO_FORM,
  'emergencyInfoForm'
)

export const savePatientMedicalHistory = makeActionCreator(PatientMedicalHistoryConstants.SAVE_PATIENT_MEDICAL_HISTORY)
